import { useAtom, useAtomValue } from 'jotai';
import { getContext } from '@fiverr-private/fiverr_context';
import { upmarketDataAtom } from '@fiverr-private/seller_pages_toolbox';
import { ROLLOUTS } from '../../server/middlewares/addRolloutsData/constants';
import { gigsAtom, rolloutsAtom } from '../atoms';

export const usePjmBannerVisibility = () => {
    const { experience } = getContext();

    const [rollouts] = useAtom(rolloutsAtom);
    const inMarlinsSellerPagePjmBannerRollout = rollouts[ROLLOUTS.MARLINS_SELLER_PAGE_PJM_BANNER];

    const [upmarketData] = useAtom(upmarketDataAtom);
    const { segment, isHighPriceAffinity } = upmarketData;
    const inProSegment = segment?.userBu === 'MP' && segment?.proBuType === 'ProFit';

    const promotedGigCategories = [10];
    const sellerGigs = useAtomValue(gigsAtom);
    const hasPromotedGigCategory = sellerGigs.some((gig) => promotedGigCategories.includes(gig.category_id));

    if (!inMarlinsSellerPagePjmBannerRollout) return false;

    if (experience.isBusiness || hasPromotedGigCategory || isHighPriceAffinity || inProSegment) return true;

    return false;
};
